// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceOutlinedSvg from "@fishx/icons-svg/es/asn/BehanceOutlined";
import FishxIcon from '../components/FishxIcon';

var BehanceOutlined = function BehanceOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceOutlinedSvg
  }));
};

BehanceOutlined.displayName = 'BehanceOutlined';
export default React.forwardRef(BehanceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BehanceOutlined.js
// module id = 2061
// module chunks = 0